// Faixa preta decorativa do hero (SVG da referência convertido para JSX).
import React from 'react';

export default function HeroBelt() {
  return (
    <div className="hero-belt-decor" aria-hidden="true">
      <svg className="hero-belt-svg" viewBox="0 0 1600 640" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice">
        <defs>
          <filter id="belt-shadow" x="-10%" y="-10%" width="130%" height="130%">
            <feDropShadow dx="0" dy="10" stdDeviation="10" floodColor="#000000" floodOpacity="0.75" />
          </filter>

          <filter id="knot-shadow" x="-20%" y="-20%" width="140%" height="140%">
            <feDropShadow dx="2" dy="8" stdDeviation="8" floodColor="#000000" floodOpacity="0.85" />
          </filter>

          <linearGradient id="belt-base-grad" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#1e232d" />
            <stop offset="25%" stopColor="#141820" />
            <stop offset="55%" stopColor="#0b0e13" />
            <stop offset="85%" stopColor="#13171f" />
            <stop offset="100%" stopColor="#0a0c10" />
          </linearGradient>

          <linearGradient id="belt-front-grad" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#242a36" />
            <stop offset="20%" stopColor="#171b24" />
            <stop offset="60%" stopColor="#0d1016" />
            <stop offset="100%" stopColor="#141820" />
          </linearGradient>

          <linearGradient id="belt-left-end-grad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#1b1f28" />
            <stop offset="35%" stopColor="#11141b" />
            <stop offset="70%" stopColor="#0d1015" />
            <stop offset="100%" stopColor="#08090d" />
          </linearGradient>

          <linearGradient id="belt-right-end-grad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#202530" />
            <stop offset="30%" stopColor="#141820" />
            <stop offset="75%" stopColor="#0c0e13" />
            <stop offset="100%" stopColor="#080a0e" />
          </linearGradient>

          <linearGradient id="belt-knot-grad" x1="15%" y1="0%" x2="85%" y2="100%">
            <stop offset="0%" stopColor="#2a3240" />
            <stop offset="30%" stopColor="#191e28" />
            <stop offset="70%" stopColor="#0c0f14" />
            <stop offset="100%" stopColor="#161a22" />
          </linearGradient>

          <linearGradient id="belt-rank-grad" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#e63946" />
            <stop offset="40%" stopColor="#c1121f" />
            <stop offset="85%" stopColor="#8f0f18" />
            <stop offset="100%" stopColor="#670b12" />
          </linearGradient>
        </defs>

        {/* 1. Camada inferior da cintura */}
        <g filter="url(#belt-shadow)">
          <path d="M-60,240 Q800,282 1660,230 L1660,320 Q800,372 -60,330 Z" fill="url(#belt-base-grad)" stroke="rgba(255,255,255,0.06)" strokeWidth="1" />
          <path d="M-60,252 Q800,294 1660,242" stroke="rgba(230,57,70,0.3)" strokeWidth="1.2" strokeDasharray="8,6" />
          <path d="M-60,272 Q800,314 1660,262" stroke="rgba(255,255,255,0.06)" strokeWidth="1" strokeDasharray="6,6" />
          <path d="M-60,292 Q800,334 1660,282" stroke="rgba(255,255,255,0.06)" strokeWidth="1" strokeDasharray="6,6" />
          <path d="M-60,310 Q800,352 1660,300" stroke="rgba(230,57,70,0.3)" strokeWidth="1.2" strokeDasharray="8,6" />
        </g>

        {/* 2. Camada superior da cintura */}
        <g filter="url(#belt-shadow)">
          <path d="M-60,222 Q800,262 1660,210 L1660,298 Q800,348 -60,308 Z" fill="url(#belt-front-grad)" stroke="rgba(255,255,255,0.08)" strokeWidth="1" />
          <path d="M-60,234 Q800,274 1660,222" stroke="rgba(230,57,70,0.38)" strokeWidth="1.2" strokeDasharray="8,6" />
          <path d="M-60,252 Q800,292 1660,240" stroke="rgba(255,255,255,0.08)" strokeWidth="1" strokeDasharray="6,6" />
          <path d="M-60,270 Q800,310 1660,258" stroke="rgba(255,255,255,0.08)" strokeWidth="1" strokeDasharray="6,6" />
          <path d="M-60,288 Q800,328 1660,276" stroke="rgba(230,57,70,0.38)" strokeWidth="1.2" strokeDasharray="8,6" />
        </g>

        {/* 3. Ponta direita (mais longa) */}
        <g filter="url(#belt-shadow)">
          <path d="M1034,295 C1042,370 1052,455 1060,540 C1064,575 1068,605 1070,622 L1134,614 C1129,575 1122,505 1112,420 C1104,360 1097,315 1092,290 Z" fill="url(#belt-right-end-grad)" stroke="rgba(255,255,255,0.07)" strokeWidth="1" />
          <path d="M1038,305 C1046,375 1056,460 1064,545 C1068,580 1071,605 1073,618" stroke="rgba(230,57,70,0.4)" strokeWidth="1.4" strokeDasharray="7,5" />
          <path d="M1054,302 C1062,372 1072,458 1080,542" stroke="rgba(255,255,255,0.06)" strokeWidth="1" strokeDasharray="6,6" />
          <path d="M1072,298 C1080,368 1090,454 1098,538" stroke="rgba(255,255,255,0.06)" strokeWidth="1" strokeDasharray="6,6" />
          <path d="M1088,295 C1096,360 1104,430 1112,510 C1118,550 1124,585 1128,610" stroke="rgba(230,57,70,0.4)" strokeWidth="1.4" strokeDasharray="7,5" />

          <path d="M1058,495 C1062,538 1066,578 1069,612 L1131,604 C1127,568 1121,528 1116,488 Z" fill="url(#belt-rank-grad)" stroke="rgba(230,57,70,0.7)" strokeWidth="1" />

          <path d="M1058,495 L1116,488" stroke="#ffffff" strokeWidth="2.5" strokeOpacity="0.8" />
          <path d="M1069,612 L1131,604" stroke="#ffffff" strokeWidth="2.5" strokeOpacity="0.8" />

          <line x1="1061" y1="520" x2="1119" y2="512" stroke="#ffffff" strokeWidth="5" strokeLinecap="round" strokeOpacity="0.9" />
          <line x1="1063" y1="542" x2="1122" y2="534" stroke="#ffffff" strokeWidth="5" strokeLinecap="round" strokeOpacity="0.9" />
          <line x1="1065" y1="564" x2="1125" y2="556" stroke="#ffffff" strokeWidth="5" strokeLinecap="round" strokeOpacity="0.9" />
          <line x1="1067" y1="586" x2="1128" y2="578" stroke="#ffffff" strokeWidth="5" strokeLinecap="round" strokeOpacity="0.9" />

          <path d="M1069,612 L1070,622 L1134,614 L1131,604 Z" fill="#090b0e" stroke="rgba(255,255,255,0.1)" strokeWidth="0.8" />
        </g>

        {/* 4. Ponta esquerda (mais curta) */}
        <g filter="url(#belt-shadow)">
          <path d="M990,305 C976,348 962,398 948,450 C945,462 942,478 939,490 L998,482 C1004,440 1014,385 1028,318 Z" fill="url(#belt-left-end-grad)" stroke="rgba(255,255,255,0.07)" strokeWidth="1" />
          <path d="M986,312 C972,354 958,404 942,488" stroke="rgba(230,57,70,0.4)" strokeWidth="1.3" strokeDasharray="7,5" />
          <path d="M1000,314 C988,362 975,418 960,486" stroke="rgba(255,255,255,0.06)" strokeWidth="1" strokeDasharray="6,6" />
          <path d="M1014,316 C1002,368 990,424 978,484" stroke="rgba(255,255,255,0.06)" strokeWidth="1" strokeDasharray="6,6" />
          <path d="M1026,320 C1012,388 1002,442 996,482" stroke="rgba(230,57,70,0.4)" strokeWidth="1.3" strokeDasharray="7,5" />
          <path d="M939,490 L942,498 L1001,490 L998,482 Z" fill="#090b0e" stroke="rgba(255,255,255,0.12)" strokeWidth="0.8" />
        </g>

        {/* 5. Nó central */}
        <g filter="url(#knot-shadow)">
          <ellipse cx="1038" cy="336" rx="55" ry="16" fill="#000000" opacity="0.6" />
          <path d="M982,268 C1014,260 1065,264 1088,278 C1102,288 1100,326 1084,345 C1066,362 1008,360 985,342 C968,328 966,288 982,268 Z" fill="url(#belt-knot-grad)" stroke="rgba(255,255,255,0.12)" strokeWidth="1.2" />
          <path d="M980,305 C1016,314 1058,310 1088,298" stroke="rgba(0,0,0,0.85)" strokeWidth="3" strokeLinecap="round" />
          <path d="M982,306 C1018,315 1058,311 1086,300" stroke="rgba(255,255,255,0.1)" strokeWidth="1.2" strokeLinecap="round" />
          <path d="M990,274 C1020,268 1058,272 1078,282" stroke="rgba(255,255,255,0.22)" strokeWidth="1.5" strokeLinecap="round" />
          <path d="M986,284 C1014,277 1052,280 1074,290" stroke="rgba(230,57,70,0.45)" strokeWidth="1.2" strokeDasharray="5,4" />
          <path d="M992,336 C1018,346 1052,344 1072,332" stroke="rgba(230,57,70,0.45)" strokeWidth="1.2" strokeDasharray="5,4" />
        </g>
      </svg>
    </div>
  );
}
